<ion-header [translucent]="false" style="box-shadow: none">

  <ion-toolbar color="primary" class="header-toolbar" style="padding: 0; --border-width: 0 0;">

    <ion-buttons slot="start">
      <ion-back-button icon="chevron-back-outline" defaultHref="/"></ion-back-button>
    </ion-buttons>

    <ion-title>{{apptitle}}</ion-title>
    <!-- <div class="header-logo" slot="start">
      <ion-img src="../../../../assets/image/farma/logo-1708601600_farma.png"></ion-img>
    </div> -->
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="logout()">
        <ion-icon slot="icon-only" name="log-out-outline"
          style="font-size: 24px;color: var(--ion-color-icon);"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ng-container *ngIf="showSearchForm">
    <form class="header-search" [formGroup]="signInForm" #signInNgForm="ngForm" (submit)="onSubmit()">
      <ion-input placeholder="Pesquisar por ..." [formControlName]="'search'">
        <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
        <ion-button fill="clear" slot="end">
          <ion-icon slot="icon-only" name="barcode-outline" aria-hidden="true"></ion-icon>
        </ion-button>
      </ion-input>
    </form>
  </ng-container>
</ion-header>
